'use client'
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'

// Tillar ma'lumotlari
export const languages = {
    uz: { code: 'uz', name: 'O\'zbekcha', flag: '🇺🇿' },
    ru: { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    en: { code: 'en', name: 'English', flag: '🇺🇸' }
}

// Tarjimalar
const translations = {
    uz: {
        // Header
        heroTitle: "Yuqori Sifatli Ko'tarish Uskunalari",
        heroDescription: "Professional xizmat va yuqori sifat kafolati bilan premium sifatli ko'tarish uskunalari.",
        products: "Mahsulotlar",
        categories: "Kategoriyalar",

        // Kategoriyalar
        "Dizelli transportlar": "Dizel vilkali yuklagich",
        "Elektri transportlar": "Elektr vilkali yuklagich", 
        "Benzinli transportlar": "Benzin-gaz yuklagich",
        "LPG transportlari": "LPG yuklagichi",
        "Elektr pallet yuk mashinasi": "Elektr pallet yuklagich",
        "Elektr stacker mashinaslari": "Elektr shtabelyor",
        "Reach truck forklift": "Reach truck yuklagich",
        "Handle pallet forklift": "Qo'l transpallet",
        "Texnika extiyot qismlarin": "Ehtiyot qismlar",

        // Navbar
        searchPlaceholder: "Forklift qidiruv...",
        searchPlaceholderMobile: "Qidiruv...",
        flag: "🇺🇿",

        // Search
        searching: "Qidirilmoqda...",
        search_error: "Qidirishda xatolik yuz berdi",
        no_results: "Hech narsa topilmadi",
        tryOtherKeywords: "Boshqa kalit so'zlarni sinab ko'ring",
        moreResults: "Yana",
        resultsCount: "ta natija",
        seeAllResults: "Barcha natijalarni ko'rish",

        // Product properties
        available: "Mavjud",
        out_of_stock: "Omborda yo'q",
        price_on_request: "Narx so'raladi",
        unnamed_product: "Nomsiz mahsulot",
        no_description: "Tavsif mavjud emas",
        no_image: "Rasm yo'q",

        // Conditions
        new: "Yangi",
        used: "Ishlatilgan",
        excellent: "A'lo",
        good: "Yaxshi",
        fair: "O'rtacha",

        // Fuel types
        diesel: "Dizel",
        electric: "Elektr",
        gas: "Gaz",
        lpg: "LPG",
        petrol: "Benzin",
        gasoline: "Benzin",

        // Common
        home: "Bosh sahifa",
        about: "Biz haqimizda",
        contact: "Aloqa",
        services: "Xizmatlar",
        news: "Yangiliklar",
        category: "Kategoriya",
        brand: "Brend",
        price: "Narx",
        capacity: "Yuk ko'tarish qobiliyati",
        year: "Yil",
        condition: "Holati",
        location: "Joylashgan joy",
        details: "Batafsil",
        specifications: "Texnik xususiyatlari",
        description: "Tavsif",
        images: "Rasmlar",
        similar: "O'xshash mahsulotlar",
        recommend: "Tavsiya etamiz",
        ton: "tonna",
        kg: "kg",
        mm: "mm",
        loading: "Yuklanmoqda...",
        error: "Xatolik yuz berdi",
        retry: "Qayta urinish",
        success: "Muvaffaqiyatli",
        warning: "Ogohlantirish",
        info: "Ma'lumot",
        back: "Orqaga",

        // Product detail
        model: "Model",
        features: "Xususiyatlar",
        place_order: "Buyurtma berish",
        request_info: "Ma'lumot so'rash",
        related_products: "O'xshash mahsulotlar",
        loading_product: "Mahsulot yuklanmoqda...",
        product_not_found: "Mahsulot topilmadi",
        api_error_fallback: "API dan ma'lumot olishda xatolik",

        // Spare Parts
        part_number: "Qism raqami",
        in_stock: "Omborda",
        compatible_with: "Mos keladi",
        original_quality: "Asl sifat",
        warranty_included: "Kafolat bilan",
        fast_delivery: "Tez yetkazib berish",

        // ProductDetail Page
        product_not_available: "Ushbu mahsulot mavjud emas",
        return_to_products: "Barcha mahsulotlarga qaytish",
        go_back: "Orqaga qaytish",
        message_send_error: "Xabar yuborishda xatolik",
        ton_capacity: "ton ko'tarish qobiliyati",
        economic_fuel: "Ekonomik yoqilg'i sarfi",
        eco_clean: "Ekologik toza ishlash",
        ergonomic_panel: "Ergonomik boshqaruv paneli",
        safety_system: "Xavfsizlik tizimi",
        easy_maintenance: "Oson texnik xizmat",
        diesel_engine: "dvigatel",
        enter_full_phone: "Telefon raqamini to'liq kiriting",
        phone_incomplete: "Telefon raqam to'liq emas",
        network_error: "Internet aloqasida xatolik",
        enter_phone: "Telefon raqamingizni qoldiring!",
        contact_message: "Biz siz bilan bog'lanamiz",
        successfully_sent: "Muvaffaqiyatli yuborildi!",
        will_contact_soon: "Tez orada bog'lanamiz",
        window_closes: "Bu oyna 3 soniyadan keyin yopiladi",
        submitting: "Yuborilmoqda...",
        buy: "Sotib olish",
        technical_specifications: "Texnik xususiyatlari",
        lifting_capacity: "Ko'tarish qobiliyati",
        fuel_type: "Yoqilg'i turi",
        engine_type: "Dvigatel",
        manufacture_year: "Ishlab chiqarilgan yili",
        availability: "Mavjudligi",
        phone_number: "Telefon raqam",

        // Footer
        call: "Qo'ng'iroq",
        telegram_channel: "Telegram kanal",
        instagram_page: "Instagram sahifa",
        youtube_channel: "YouTube kanal",
        facebook_page: "Facebook sahifa",
        all_rights_reserved: "Barcha huquqlar himoyalangan",
        contact_us: "Biz bilan bog'laning",

        // CategoryDetailPage
        all_categories: "Barcha kategoriyalar",
        no_products: "Mahsulotlar topilmadi",
        no_products_desc: "Ushbu kategoriyada mahsulotlar mavjud emas",
        more_info: "Batafsil",
        products_count: "mahsulot",
        spare_part: "Ehtiyot qism",

        // Qo'shimcha spare parts translations
        forklift: "forklift",
        availability: "Mavjudligi",
        compatibility: "Mos kelishi",
        stock: "Omborda",
        piece: "dona",
        pieces: "dona"
    },

    ru: {
        // Header
        heroTitle: "Высококачественное подъёмное оборудование",
        heroDescription: "Подъёмное оборудование премиум-класса с профессиональным сервисом.",
        products: "Продукция",
        categories: "Категории",

        // Kategoriyalar
        "Dizelli transportlar": "Дизельные вилочные погрузчики",
        "Elektri transportlar": "Электрические вилочные погрузчики",
        "Benzinli transportlar": "Газо-бензиновые погрузчики",
        "LPG transportlari": "LPG погрузчики",
        "Elektr pallet yuk mashinasi": "Электрические рохли",
        "Elektr stacker mashinaslari": "Электрические штабелеры",
        "Reach truck forklift": "Ричтрак погрузчики",
        "Handle pallet forklift": "Ручные транспаллеты",
        "Texnika extiyot qismlarin": "Запчасти для погрузчиков",

        // Navbar
        searchPlaceholder: "Поиск погрузчика...",
        searchPlaceholderMobile: "Поиск...",
        flag: "🇷🇺",

        // Search
        searching: "Поиск...",
        search_error: "Ошибка при поиске",
        no_results: "Ничего не найдено",
        tryOtherKeywords: "Попробуйте другие ключевые слова",
        moreResults: "Еще",
        resultsCount: "результатов",
        seeAllResults: "Посмотреть все результаты",

        // Product properties
        available: "Доступно",
        out_of_stock: "Нет в наличии",
        price_on_request: "Цена по запросу",
        unnamed_product: "Без названия",
        no_description: "Описание отсутствует",
        no_image: "Нет изображения",

        // Conditions
        new: "Новый",
        used: "Б/у",
        excellent: "Отличное",
        good: "Хорошее",
        fair: "Удовлетворительное",

        // Fuel types
        diesel: "Дизель",
        electric: "Электрический",
        gas: "Газ",
        lpg: "LPG",
        petrol: "Бензин",
        gasoline: "Бензин",

        // Common
        home: "Главная",
        about: "О нас",
        contact: "Контакты",
        services: "Услуги",
        news: "Новости",
        category: "Категория",
        brand: "Бренд",
        price: "Цена",
        capacity: "Грузоподъемность",
        year: "Год",
        condition: "Состояние",
        location: "Местоположение",
        details: "Подробнее",
        specifications: "Технические характеристики",
        description: "Описание",
        images: "Изображения",
        similar: "Похожие товары",
        recommend: "Рекомендуем",
        ton: "тонн",
        kg: "кг",
        mm: "мм",
        loading: "Загрузка...",
        error: "Произошла ошибка",
        retry: "Повторить",
        success: "Успешно",
        warning: "Предупреждение",
        info: "Информация",
        back: "Назад",

        // Product detail
        model: "Модель",
        features: "Особенности",
        place_order: "Сделать заказ",
        request_info: "Запросить информацию",
        related_products: "Похожие товары",
        loading_product: "Загрузка товара...",
        product_not_found: "Товар не найден",
        api_error_fallback: "Ошибка получения данных",

        // Spare Parts
        part_number: "Номер детали",
        in_stock: "В наличии",
        compatible_with: "Совместимо с",
        original_quality: "Оригинальное качество",
        warranty_included: "С гарантией",
        fast_delivery: "Быстрая доставка",

        // ProductDetail Page
        product_not_available: "Данный товар недоступен",
        return_to_products: "Вернуться ко всем товарам",
        go_back: "Назад",
        message_send_error: "Ошибка при отправке сообщения",
        ton_capacity: "тонн грузоподъемность",
        economic_fuel: "Экономичный расход топлива",
        eco_clean: "Экологически чистая работа",
        ergonomic_panel: "Эргономичная панель управления",
        safety_system: "Система безопасности",
        easy_maintenance: "Простое техническое обслуживание",
        diesel_engine: "двигатель",
        enter_full_phone: "Введите полный номер телефона",
        phone_incomplete: "Номер телефона неполный",
        network_error: "Ошибка интернет-соединения",
        enter_phone: "Оставьте номер телефона!",
        contact_message: "Мы свяжемся с вами",
        successfully_sent: "Успешно отправлено!",
        will_contact_soon: "Мы свяжемся с вами",
        window_closes: "Окно закроется через 3 секунды",
        submitting: "Отправляется...",
        buy: "Купить",
        technical_specifications: "Технические характеристики",
        lifting_capacity: "Грузоподъемность",
        fuel_type: "Тип топлива",
        engine_type: "Двигатель",
        manufacture_year: "Год производства",
        availability: "Наличие",
        phone_number: "Номер телефона",

        // Footer
        call: "Позвонить",
        telegram_channel: "Telegram канал",
        instagram_page: "Instagram страница",
        youtube_channel: "YouTube канал",
        facebook_page: "Facebook страница",
        all_rights_reserved: "Все права защищены",
        contact_us: "Свяжитесь с нами",

        // CategoryDetailPage
        all_categories: "Все категории",
        no_products: "Товары не найдены",
        no_products_desc: "В данной категории нет товаров",
        more_info: "Подробнее",
        products_count: "товаров",
        spare_part: "Запчасть",

        // Qo'shimcha spare parts translations
        forklift: "forklift",
        availability: "Наличие",
        compatibility: "Совместимость",
        stock: "На складе",
        piece: "шт",
        pieces: "шт"
    },

    en: {
        // Header
        heroTitle: "High Quality Lifting Equipment",
        heroDescription: "Premium quality lifting equipment with professional service.",
        products: "Products",
        categories: "Categories",

        // Kategoriyalar
        "Dizelli transportlar": "Diesel Forklifts",
        "Elektri transportlar": "Electric Forklifts",
        "Benzinli transportlar": "Gas/Petrol Forklifts",
        "LPG transportlari": "LPG Forklifts",
        "Elektr pallet yuk mashinasi": "Electric Pallet Trucks",
        "Elektr stacker mashinaslari": "Electric Stackers",
        "Reach truck forklift": "Reach Truck Forklifts",
        "Handle pallet forklift": "Manual Pallet Trucks",
        "Texnika extiyot qismlarin": "Forklift Spare Parts",

        // Navbar
        searchPlaceholder: "Search forklift...",
        searchPlaceholderMobile: "Search...",
        flag: "🇺🇸",

        // Search
        searching: "Searching...",
        search_error: "Search error occurred",
        no_results: "No results found",
        tryOtherKeywords: "Try other keywords",
        moreResults: "More",
        resultsCount: "results",
        seeAllResults: "See all results",

        // Product properties
        available: "Available",
        out_of_stock: "Out of stock",
        price_on_request: "Price on request",
        unnamed_product: "Unnamed product",
        no_description: "No description available",
        no_image: "No image",

        // Conditions
        new: "New",
        used: "Used",
        excellent: "Excellent",
        good: "Good",
        fair: "Fair",

        // Fuel types
        diesel: "Diesel",
        electric: "Electric",
        gas: "Gas",
        lpg: "LPG",
        petrol: "Petrol",
        gasoline: "Gasoline",

        // Common
        home: "Home",
        about: "About",
        contact: "Contact",
        services: "Services",
        news: "News",
        category: "Category",
        brand: "Brand",
        price: "Price",
        capacity: "Load capacity",
        year: "Year",
        condition: "Condition",
        location: "Location",
        details: "Details",
        specifications: "Specifications",
        description: "Description",
        images: "Images",
        similar: "Similar products",
        recommend: "Recommended",
        ton: "ton",
        kg: "kg",
        mm: "mm",
        loading: "Loading...",
        error: "An error occurred",
        retry: "Retry",
        success: "Success",
        warning: "Warning",
        info: "Information",
        back: "Back",

        // Product detail
        model: "Model",
        features: "Features",
        place_order: "Place Order",
        request_info: "Request Information",
        related_products: "Related Products",
        loading_product: "Loading product...",
        product_not_found: "Product not found",
        api_error_fallback: "API data fetch error",

        // Spare Parts
        part_number: "Part Number",
        in_stock: "In Stock",
        compatible_with: "Compatible with",
        original_quality: "Original Quality",
        warranty_included: "With Warranty",
        fast_delivery: "Fast Delivery",

        // ProductDetail Page
        product_not_available: "This product is not available",
        return_to_products: "Return to all products",
        go_back: "Go back",
        message_send_error: "Error sending message",
        ton_capacity: "ton lifting capacity",
        economic_fuel: "Economic fuel consumption",
        eco_clean: "Eco-friendly operation",
        ergonomic_panel: "Ergonomic control panel",
        safety_system: "Safety system",
        easy_maintenance: "Easy maintenance",
        diesel_engine: "engine",
        enter_full_phone: "Enter full phone number",
        phone_incomplete: "Phone number is incomplete",
        network_error: "Internet connection error",
        enter_phone: "Leave your phone number!",
        contact_message: "We will contact you",
        successfully_sent: "Successfully sent!",
        will_contact_soon: "We will contact you soon",
        window_closes: "Window will close in 3 seconds",
        submitting: "Submitting...",
        buy: "Buy",
        technical_specifications: "Technical Specifications",
        lifting_capacity: "Lifting Capacity",
        fuel_type: "Fuel Type",
        engine_type: "Engine",
        manufacture_year: "Year of Manufacture",
        availability: "Availability",
        phone_number: "Phone Number",

        // Footer
        call: "Call",
        telegram_channel: "Telegram channel",
        instagram_page: "Instagram page",
        youtube_channel: "YouTube channel",
        facebook_page: "Facebook page",
        all_rights_reserved: "All rights reserved",
        contact_us: "Contact us",

        // CategoryDetailPage
        all_categories: "All Categories",
        no_products: "No products found",
        no_products_desc: "No products in this category",
        more_info: "More Info",
        products_count: "products",
        spare_part: "Spare Part",

        // Qo'shimcha spare parts translations
        forklift: "forklift",
        availability: "Availability",
        compatibility: "Compatibility", 
        stock: "In Stock",
        piece: "pcs",
        pieces: "pcs"
    }
}

// Context yaratish
const LanguageContext = createContext()

// Provider component
export const LanguageProvider = ({ children }) => {
    const [currentLang, setCurrentLang] = useState('uz')
    const [isHydrated, setIsHydrated] = useState(false)
    const [isChanging, setIsChanging] = useState(false)
    const [forceUpdateKey, setForceUpdateKey] = useState(0)

    // Client-side localStorage
    useEffect(() => {
        const savedLang = localStorage.getItem('language')
        if (savedLang && languages[savedLang]) {
            setCurrentLang(savedLang)
        }
        setIsHydrated(true)
    }, [])

    // Force update listener
    useEffect(() => {
        const handleForceUpdate = () => {
            setForceUpdateKey(prev => prev + 1)
        }

        window.addEventListener('languageForceUpdate', handleForceUpdate)
        window.addEventListener('forceComponentUpdate', handleForceUpdate)
        
        return () => {
            window.removeEventListener('languageForceUpdate', handleForceUpdate)
            window.removeEventListener('forceComponentUpdate', handleForceUpdate)
        }
    }, [])

    // Tilni o'zgartirish
    const changeLanguage = useCallback((langCode) => {
        if (languages[langCode] && langCode !== currentLang) {
            setIsChanging(true)
            setCurrentLang(langCode)
            localStorage.setItem('language', langCode)
            setForceUpdateKey(prev => prev + 1)
            
            setTimeout(() => {
                setIsChanging(false)
                setForceUpdateKey(prev => prev + 1)
            }, 150)
            
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('languageChanged', { 
                    detail: { newLang: langCode, timestamp: Date.now() } 
                }))
                window.dispatchEvent(new CustomEvent('languageForceUpdate', {
                    detail: { newLang: langCode, timestamp: Date.now() }
                }))
                setForceUpdateKey(prev => prev + 1)
            }, 50)
        }
    }, [currentLang])

    // Tarjima olish
    const t = React.useMemo(() => {
        return translations[currentLang] || translations.uz
    }, [currentLang, forceUpdateKey])

    // Dynamic translation
    const getTranslation = useCallback((key, fallback = '') => {
        return t[key] || fallback || key
    }, [t])

    // Server data translator
    const translateServerData = useCallback((data, type = 'product') => {
        if (!data) return data;

        switch (type) {
            case 'product':
                return {
                    ...data,
                    displayName: data.name || `${data.brand?.name || ''} ${data.model || ''}`.trim() || t.unnamed_product,
                    categoryName: t[data.category?.name] || data.category?.name,
                    conditionText: t[data.condition?.toLowerCase()] || data.condition,
                    fuelTypeText: t[data.fuel_type?.toLowerCase()] || data.fuel_type,
                    availabilityText: data.quantity_in_stock > 0 ? `${data.quantity_in_stock} ${t.available}` : t.out_of_stock
                };
            case 'category':
                return t[data.name] || data.name;
            default:
                return data;
        }
    }, [t])

    // Context value
    const value = React.useMemo(() => ({
        currentLang,
        changeLanguage,
        t,
        languages,
        translations,
        isHydrated,
        isChanging,
        forceUpdateKey,
        translateServerData,
        getTranslation
    }), [currentLang, changeLanguage, t, isHydrated, isChanging, forceUpdateKey, translateServerData, getTranslation])

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    )
}

// Hook
export const useLanguage = () => {
    const context = useContext(LanguageContext)
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider')
    }
    return context
}

export default LanguageContext